import { render, staticRenderFns } from "./tax-relief.vue?vue&type=template&id=6f23728c"
import script from "./tax-relief.vue?vue&type=script&lang=js"
export * from "./tax-relief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports